import { get } from 'lodash';
import { requestAPI } from 'services/request';

const requestConnectAPI = async ({ ...rest }) =>
  requestAPI('POST', '/transactions/connect/request', {}, { ...rest });

const request = async () => {
  const res = await requestConnectAPI({});
  return get(res, 'data', {});
};

export const TRANSACTIONS_CONNECT_API = {
  request,
};
